import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const getApiService = (userId, orderId) =>
    `${apiUtils.getBaseUri()}/users/${userId || 'anonymous'}/orders${
        typeof orderId === 'string' && orderId !== '' ? `/${orderId}` : ''
    }`;

const getParams = (currentPage, pageSize, statuses, fields = '') =>
    `?fields=${typeof fields === 'string' && fields !== '' ? fields : 'FULL'}` +
    `${typeof pageSize === 'number' ? `&pageSize=${pageSize}` : ''}` +
    `${typeof currentPage === 'number' ? `&currentPage=${currentPage}` : ''}` +
    `${statuses ? `&statuses=${statuses}` : ''}`;

const getOrders = async (userId, currentPage = 0, pageSize, statuses, fields = '') => {
    const uri = `${getApiService(userId)}${getParams(currentPage, pageSize, statuses, fields)}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load orders (${response.status})`);
    }
    return await response.json();
};

const getOfflineOrders = async userId => {
    const uri = `${getApiService(userId)}/offline`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load orders (${response.status})`);
    }
    return await response.json();
};

export default {
    getOrders,
    getOfflineOrders,
};
